export default __webpack_public_path__ + "static/media/1-talento.eeb35a94.svg";